document.addEventListener("DOMContentLoaded", () => {
  const elements = {
    sizeOptions: Array.from(document.querySelectorAll(".size-option")) as HTMLElement[],
    roomSizeEl: document.getElementById("room-size") as HTMLElement | null,
    roomDimensionsEl: document.getElementById("room-dimensions") as HTMLElement | null,
    roomDimensionsMobEl: document.getElementById("room-dimensions-mob") as HTMLElement | null,
    roomContentEl: document.getElementById("room-content") as HTMLElement | null,
    roomContentMobEl: document.getElementById("room-content-mob") as HTMLElement | null,
    roomGif: document.getElementById("room-gif") as HTMLImageElement | null,
    roomKey: document.getElementById("room-key") as HTMLInputElement | null,
    roomKeyMob: document.getElementById("room-key-mob") as HTMLInputElement | null,
    roomSizes: document.querySelector(".room-sizes") as HTMLElement | null,
    roomSizesContainer: document.querySelector(".room-sizes-slider") as HTMLElement | null,
    prevBtn: document.querySelector(".prev-btn") as HTMLElement | null,
    nextBtn: document.querySelector(".next-btn") as HTMLElement | null,
  };

  let currentSlide = 2; // Default to the third slide (0-based index)
  const totalSlides = elements.sizeOptions.length;
  let itemsPerView = 5;
  let sizeOptionWidth = 0;

  const isMobile = (): boolean => window.innerWidth < 576;

  function debounce<T extends (...args: unknown[]) => void>(func: T, wait: number): (...args: Parameters<T>) => void {
    let timeout: number | null = null;
    return (...args: Parameters<T>): void => {
      if (timeout !== null) clearTimeout(timeout);
      timeout = window.setTimeout(() => func(...args), wait);
    };
  }

  function updateRoomInfo(option: HTMLElement): void {
    const roomSize = option.getAttribute("data-size") || "";
    const roomDimensions = option.getAttribute("data-dimensions") || "";
    const roomContent = option.getAttribute("data-content") || "";
    const roomGifDesktop = option.getAttribute("data-gif-desktop") || "";
    const roomGifMobile = option.getAttribute("data-gif-mobile") || "";
    const gifSource = isMobile() ? roomGifMobile : roomGifDesktop;
    const roomKey = option.getAttribute("data-key") || "";

    if (elements.roomSizeEl) elements.roomSizeEl.textContent = roomSize;
    if (elements.roomDimensionsEl) elements.roomDimensionsEl.textContent = roomDimensions;
    if (elements.roomDimensionsMobEl) elements.roomDimensionsMobEl.textContent = roomDimensions;
    if (elements.roomContentEl) elements.roomContentEl.innerHTML = roomContent.replace(/\n/g, "<br>");
    if (elements.roomContentMobEl) elements.roomContentMobEl.innerHTML = roomContent.replace(/\n/g, "<br>");
    if (elements.roomKey) elements.roomKey.value = roomKey;
    if (elements.roomKeyMob) elements.roomKeyMob.value = roomKey;

    if (elements.roomGif && gifSource) {
      const currentGif = elements.roomGif.src;
      if (currentGif !== gifSource) {
        elements.roomGif.src = gifSource;
      }
    }
  }

  function centerSelectedSlide(): void {
    if (!elements.roomSizesContainer || !elements.roomSizes) return;
    const translateX = Math.min(
      0,
      Math.max(
        -(currentSlide * sizeOptionWidth - elements.roomSizesContainer.clientWidth / 2 + sizeOptionWidth / 2),
        -(totalSlides * sizeOptionWidth - elements.roomSizesContainer.clientWidth)
      )
    );
    elements.roomSizes.style.transform = `translateX(${translateX}px)`;
    elements.roomSizes.style.transition = "transform 0.3s ease";
  }

  function selectCurrentSlide(): void {
    elements.sizeOptions.forEach((opt) => opt.classList.remove("active"));
    const currentOption = elements.sizeOptions[currentSlide];
    currentOption?.classList.add("active");
    updateRoomInfo(currentOption);
    centerSelectedSlide();
  }

  function nextSlide(): void {
    currentSlide = (currentSlide + 1) % totalSlides; // Loop back to the first slide
    selectCurrentSlide();
  }

  function prevSlide(): void {
    currentSlide = (currentSlide - 1 + totalSlides) % totalSlides; // Loop back to the last slide
    selectCurrentSlide();
  }

  function initialize(): void {
    const containerWidth = elements.roomSizesContainer?.clientWidth || 0;
    itemsPerView = window.innerWidth > 992 ? 5 : window.innerWidth > 768 ? 3 : 1;
    sizeOptionWidth = containerWidth / itemsPerView;

    elements.sizeOptions.forEach((option) => {
      option.style.width = `${sizeOptionWidth}px`;
    });

    const targetOption = elements.sizeOptions.find(
      (option) => option.getAttribute("data-size") === "25 sq ft"
    );

    if (targetOption) {
      currentSlide = elements.sizeOptions.indexOf(targetOption);
    } else {
      currentSlide = totalSlides > 2 ? 2 : totalSlides - 1;
    }

    selectCurrentSlide();
  }

  if (elements.nextBtn) elements.nextBtn.addEventListener("click", nextSlide);
  if (elements.prevBtn) elements.prevBtn.addEventListener("click", prevSlide);

  elements.sizeOptions.forEach((option, index) => {
    option.addEventListener("click", () => {
      currentSlide = index;
      selectCurrentSlide();
    });
  });

  window.addEventListener(
    "resize",
    debounce(() => {
      const prevSlide = currentSlide;
      initialize();
      currentSlide = prevSlide;
      selectCurrentSlide();
    }, 100)
  );

  initialize();
});
